import React from 'react';
import { StyledBundlePrice } from './style';
import { PMBundlePriceProps } from 'utils/types';
import { ActualPrice } from 'components/BundlePrice/ActualPrice';

const HeartOfVegasBundlePrice: React.FC<PMBundlePriceProps> = ({
  prices,
  bundleButtonColor,
  bundleButtonTextColor = 'white',
}) => {
  return (
    <StyledBundlePrice
      bundleButtonColor={bundleButtonColor}
      bundleButtonTextColor={bundleButtonTextColor}
    >
      <div className="heart-of-vegas-casino__price-button totalPrice">
        <ActualPrice prices={prices} />
      </div>
    </StyledBundlePrice>
  );
};

export default HeartOfVegasBundlePrice;
